import { useState, useCallback, useMemo } from "react";
import { DeleteAccountDialogContext } from "./DeleteAccountDialogContext";
import { DeleteAccountDialog } from "./DeleteAccountDialog";

export const DeleteAccountDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const contextValue = useMemo(
    () => ({
      open,
      close,
      isOpen,
    }),
    [open, close, isOpen]
  );

  return (
    <DeleteAccountDialogContext.Provider value={contextValue}>
      <DeleteAccountDialog />
      {children}
    </DeleteAccountDialogContext.Provider>
  );
};
